import { PaletteOptions } from '@mui/material';
import { ColorsConfig } from 'config/constant/colors.config';
import { AppPaletteMode } from 'config/enums/app.enum';

const lightPalette: PaletteOptions = {
  mode: AppPaletteMode.Light,
  primary: ColorsConfig.primary,
  secondary: ColorsConfig.secondary,
  info: ColorsConfig.info,
  success: ColorsConfig.success,
  warning: ColorsConfig.warning,
  error: ColorsConfig.error,
  grey: ColorsConfig.grey,
  background: ColorsConfig.background,
  text: ColorsConfig.text,
  action: ColorsConfig.actions,
};

export default lightPalette;
